import React from 'react';
import Image from '../components/Image';
import { useSiteConfigDetails } from '../features/siteConfig/siteConfigSlice';
import '../global-sass/main.scss';

const Widget = () => {
	const logosPaths = useSiteConfigDetails();

	return (
		<div className="d-flex flex-wrap justify-content-between align-items-center align-content-center gap-3 w-100">
			{logosPaths.map((logoPath) => (
				<Image key={logoPath} src={logoPath} />
			))}
		</div>
	);
};

export default Widget;
